export const marketingUrl: string =
  "https://www.mollie.com/products/payment-links";
export const paymentLinksApiUrl: string = import.meta.env
  .VITE_PAYMENT_LINKS_API_URL;
